/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  // Optional `inboxIds` (array of numeric ids) restricts the mark-all-read
  // action to those inboxes. Omitting the argument keeps the legacy behavior
  // (marks all inboxes the user has access to in the account).
  markAllRead({ inboxIds } = {}) {
    const payload = {};
    if (Array.isArray(inboxIds) && inboxIds.length > 0) {
      payload.inbox_ids = inboxIds;
    }
    return axios.post(`${this.url}/mark_all_read`, payload);
  }
}

export default new ConversationApi();
